import { render, staticRenderFns } from "./ModuleButton.vue?vue&type=template&id=121beee5&"
import script from "./ModuleButton.vue?vue&type=script&lang=js&"
export * from "./ModuleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports